// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/flaticon/flaticon.css
// module id = 2817
// module chunks = 0